import { isRequired } from './isRequired';
import { always, isNil, mergeLeft, when } from 'ramda';
import { Validator } from '@fasstech/oip-core/entities/helpers/validator';

export const emailIsValid = (value) => Validator({ type: 'mail' }).validate(value)[0];

export const emailRules = (required = true) =>
  when(always(required), mergeLeft(isRequired), {
    validate: (value) =>
      (!isNil(value) && value.length ? emailIsValid(value) : !required) ||
      'Le format de l\'email saisi est invalide'
  });
